import React, { FC } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import useI18n from 'evcharging/hooks/useI18n';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
);

const createData = (
  t: (id: string) => string,
  days: number[],
  expenses: number[],
  revenue: number[],
  profit: number[],
) => ({
  labels: days,
  datasets: [
    {
      label: t('calculator.result.revenue'),
      backgroundColor: '#f9c103',
      data: revenue,
      borderRadius: 10,
    },
    {
      label: t('calculator.result.total'),
      backgroundColor: '#c54848',
      data: expenses,
      borderRadius: 10,
    },
    {
      label: t('calculator.result.profit'),
      backgroundColor: '#59ba49',
      data: profit,
      borderRadius: 10,
    },
  ],
});

interface CalculatorChartProps {
  days: number[];
  expenses: number[];
  revenue: number[];
  profit: number[];
}

const CalculatorChart: FC<CalculatorChartProps> = (props) => {
  const { days, expenses, revenue, profit } = props;
  const { t } = useI18n();
  const data = createData(t, days, expenses, revenue, profit);
  return <Bar data={data} options={options} />;
};

const options = {
  plugins: {
    legend: {
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
      },
    },
    tooltip: {
      intersect: false,
      interaction: {
        mode: 'index',
      },
      usePointStyle: true,
      pointStyle: 'circle',
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
};

export default CalculatorChart;
